/** @file A mirrorFix direction's fix: overlay skin, draw-order ops, per-base fix animations (setFix). */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Dir, DirectionEntry, Doc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { Select } from '../../ui-kit/Select';
import type { RunCommands } from '../rigKit/rigView';
import { FixAnimations } from './FixAnimations';
import { FixOps } from './FixOps';

/** Props of FixEditor; `fix` is the entry's current fix (undefined = none yet). */
export interface FixEditorProps {
  doc: Doc;
  t: Translate;
  run: RunCommands;
  dir: Dir;
  fix: DirectionEntry['fix'];
}

/** Each change sends one setFix with only its own part: skin (null removes), the whole op list, or one base. */
export function FixEditor({ doc, t, run, dir, fix }: FixEditorProps) {
  const setFix = (part: Record<string, unknown>): void => { run([{ name: 'direction.setFix', input: { dir, ...part } }]); };
  const skins = [{ value: '', label: t('panels.directions.noChoice') }, ...entriesByName(doc.skins).map(([value, s]) => ({ value, label: s.name }))];
  return (
    <div className="rig-body">
      <Select label={t('panels.directions.fixSkin')} value={fix?.skin ?? ''} options={skins} onChange={(skin) => { setFix({ skin: skin === '' ? null : skin }); }} />
      <FixOps doc={doc} t={t} ops={fix?.drawOrderOps ?? []} onChange={(drawOrderOps) => { setFix({ drawOrderOps }); }} />
      <FixAnimations doc={doc} t={t} animations={fix?.animations ?? {}} onChange={(base, animation) => { setFix({ animations: { [base]: animation } }); }} />
    </div>
  );
}
